import { Text } from '@avanta/shared/components/Text';
import { type LucideIcon } from 'lucide-react';

interface PatientInfoRowProps {
  icon: LucideIcon;
  value: string;
}

export const PatientInfoRow = ({ icon: Icon, value }: PatientInfoRowProps): React.ReactElement => (
  <div className="flex w-full min-w-0 items-center gap-2">
    <Icon aria-hidden className="size-4.5 shrink-0 text-teal-600" strokeWidth={1.25} />
    <Text variant="text-sm-regular" className="min-w-0 flex-1 text-denim-800 truncate">
      {value}
    </Text>
  </div>
);
